module.exports = __webpack_public_path__ + "static/media/success_cloud.5fdc08ed.svg";